export default __webpack_public_path__ + "static/media/icon-coin-xaut.46d5d168.svg";